export default "__VITE_ASSET__BC5mRh8j__"